import { toDecimal4, toDecimal10 } from 'src/utils/toDecimal';
export const getVAT = (
  grossAmt = 0,
  rate = 0.12,
  vatCode = 1,
  amtType = 'IN'
) => {
  let vatIN = 0,
    vatOUT = 0;
  const rt = (rate * 100 + 100) / 100;

  if (vatCode !== 1) {
    return {
      vatIN,
      vatOUT
    };
  }

  //* PUR
  if (amtType === 'IN') {
    return {
      vatIN: (grossAmt / rt) * rate,
      vatOUT
    };
  }

  if (amtType === 'OUT' || amtType === 'SO') {
    return {
      vatIN,
      vatOUT: (grossAmt / rt) * rate
    };
  }

  return {
    vatIN,
    vatOUT
  };
};

export function calculateVAT(gross, vatRate = 0.12, vatCode = 1) {
  const rate = 1 + vatRate;
  let amount = 0;

  if (vatCode === 1) {
    amount = toDecimal4((gross / rate) * vatRate);
  }

  return amount;
}

export function calculateMarkup(gross, muRate) {
  let amount = gross;

  Object.values(muRate).forEach(rate => {
    amount = (rate + 1) * amount;
  });

  return toDecimal4(amount - gross);
}

export function calculateOutrightDisc(gross, discOutrightRate) {
  let amount = gross;

  Object.values(discOutrightRate).forEach(rate => {
    amount = (1 - rate) * amount;
  });

  return toDecimal4(gross - amount);
}

function CalculateDiscountsAndVAT() {
  const data = {
    priceGross: 0,
    unit_priceGross: 0,
    netPrice: 0,
    qty: 0,

    muAmt: 0,
    muRate: {
      1: 0,
      2: 0,
      3: 0,
      4: 0,
      5: 0
    },
    muSubTotal: 0,

    discOutrightAmt: 0,
    discOutrightRate: {
      1: 0,
      2: 0,
      3: 0,
      4: 0,
      5: 0
    },
    discOutrightSubTotal: 0,

    discRate: 0,
    discAmt: 0,
    discSubTotal: 0,

    cPriceAmt: 0,
    discQtyRate: 0, // multiplied to qty
    discQtySubTotal: 0,
    discQtyNetAmt: 0,
    discQtyAmt: 0, // product of qty and ratediscQtyAmt

    discValue: 0,
    discValueTotal: 0,
    discValueSubTotal: 0,

    vatIN: 0,
    vatINAmt: 0,

    vatOUT: 0,
    vatOUTAmt: 0,

    // new price vat
    new_price: 0,
    new_vatIN: 0,
    new_vatINAmt: 0,

    taxablePrice: 0,

    SCPWDDiscountAmt: 0,

    // discount settings
    muAllow: false,
    includeMarkUpInTaxableAmount: true,

    discOutrightAllow: false,
    includeDiscOutrightInTaxableAmount: true,

    discQtyAllow: true,

    discByPercentAllow: false,
    includeDiscByPercentInTaxableAmount: true,

    discByValueAllow: false,
    includeDiscByValueInTaxableAmount: false,

    // for senior citizen and pwd
    discountRatio: 0,
    SCPWDRate: 0,

    // vat Settings
    vatRate: 0.12,
    vatAmtType: 'NONE',
    vatCode: 1,
    calcVAT: false,

    showReprice: false
  };

  function set(values = {}) {
    Object.entries(values).forEach(([key, value]) => {
      data[key] = value;
    });
  }

  function calculate() {
    const qty = toDecimal4(+data.qty);
    let taxablePrice = toDecimal4(+data.priceGross),
      taxableAmt = toDecimal4(+data.priceGross * qty),
      netPrice = toDecimal4(+data.priceGross),
      // initialize netAmount
      netAmt = toDecimal4(+data.priceGross * qty),
      muAmt = 0,
      discOutrightAmt = 0,
      discAmt = 0;

    if (data.muAllow) {
      muAmt = calculateMarkup(netAmt, data.muRate);

      // add the muAmt to netAmt
      netAmt = netAmt + muAmt;

      data.muAmt = muAmt;
      data.muSubTotal = netAmt;
      if (data.includeMarkUpInTaxableAmount) {
        taxablePrice = taxableAmt + muAmt;
        taxableAmt += muAmt;
      }
    }

    // Outright Discount
    if (data.discOutrightAllow) {
      discOutrightAmt = calculateOutrightDisc(netAmt, data.discOutrightRate);
      netAmt -= discOutrightAmt;
      data.discOutrightAmt = discOutrightAmt;
      data.discOutrightSubTotal = netAmt;
      if (data.includeDiscOutrightInTaxableAmount) {
        taxablePrice = taxablePrice - discOutrightAmt;
        taxableAmt -= discOutrightAmt;
      }
    }

    // Discount by Percentage
    if (data.discByPercentAllow) {
      discAmt = toDecimal4(calculateDiscByPercentage(netAmt));
      netAmt -= discAmt;
      data.discAmt = discAmt;
      data.discSubTotal = netAmt;
      if (data.includeDiscByPercentInTaxableAmount) taxableAmt -= discAmt;
    }

    /* 
      Discount by Fixed Value
    */
    if (data.discByValueAllow) {
      let disc_val = data.discValueTotal,
        sub_total = 0;

      //
      sub_total = netAmt - data.discValueTotal;
      data.discValue = disc_val;
      data.discValueSubTotal = sub_total;
      netAmt -= disc_val;
      if (data.includeDiscByValueInTaxableAmount) taxableAmt -= disc_val;
    }

    // Discount by Qty
    if (data.discQtyAllow) {
      let discQtyRate = data.discQtyRate || 0;
      let discQtyAmt = data.discQtyAmt || 0;
      let discQtySubTotal = data.discQtySubTotal || 0;
      let discQtyNetAmt = data.discQtyNetAmt || 0;

      const rate = discQtyRate * qty;
      const priceAmt = taxableAmt;
      discQtyAmt = (priceAmt - rate) / qty;
      discQtySubTotal = rate;
      discQtyNetAmt = priceAmt - discQtySubTotal;

      data.discQtyRate = toDecimal4(discQtyRate);
      data.discQtySubTotal = toDecimal4(discQtySubTotal);
      data.discQtyNetAmt = toDecimal4(discQtyNetAmt);
      data.discQtyAmt = toDecimal4(discQtySubTotal);
    }

    if (data.discountRatio > 0 && data.SCPWDRate > 0)
      data.SCPWDDiscountAmt = calculateProRatedDiscount({
        gross: netAmt,
        discount_ratio: data.discountRatio,
        rate: data.SCPWDRate
      });

    if (data.calcVAT) {
      const vat = calculateVAT(taxableAmt, data.vatRate, data.vatCode);
      if (data.vatAmtType === 'IN') {
        data.vatIN = toDecimal10(vat / qty);
        data.vatINAmt = toDecimal4(vat);
        data.vatOUT = 0;
        data.vatOUTAmt = 0;
      } else if (data.vatAmtType === 'OUT' || data.vatAmtType === 'SO') {
        data.vatIN = 0;
        data.vatINAmt = 0;
        data.vatOUT = toDecimal10(vat / qty);
        data.vatOUTAmt = toDecimal4(vat);
      } else {
        data.vatIN = 0;
        data.vatINAmt = 0;
        data.vatOUT = 0;
        data.vatOUTAmt = 0;
      }
    }

    if (data.calcVAT && data.showReprice) {
      const vat = calculateVAT(
        data.new_price * qty,
        data.vatRate,
        data.vatCode
      );
      data.new_vatIN = toDecimal10(vat / qty);
      data.new_vatINAmt = toDecimal4(vat);
    }

    // update the values of data
    data.netPrice = toDecimal4(netAmt / qty);
    data.taxablePrice = toDecimal4(taxableAmt / qty);
    data.taxableAmt = toDecimal4(taxableAmt);

    data.muAmt = toDecimal4(data.muAmt / qty);
    data.muSubTotal = toDecimal4(data.muSubTotal);

    data.discOutrightAmt = toDecimal4(discOutrightAmt);
    data.discOutrightSubTotal = toDecimal4(data.discOutrightSubTotal);

    return data;
  }

  function calculateDiscByPercentage(gross) {
    return gross - (1 - +data.discRate) * gross;
  }

  function calculateProRatedDiscount({
    gross = 0,
    discount_ratio = 0,
    rate = 0
  }) {
    const amt = gross * discount_ratio;
    const vat = calculateVAT(amt, data.vatRate, data.vatCode);
    const netOfVAT = amt - vat;

    return netOfVAT * rate;
  }

  return {
    data,
    set,
    calculate
  };
}

export default CalculateDiscountsAndVAT;
